import { defaulted, type Infer, literal, nullable, object, string, union } from "superstruct";

export const TitleLevelSchema = union([literal(1), literal(2), literal(3)]);
export type TitleLevel = Infer<typeof TitleLevelSchema>;

export const TitleBlockSchema = object({
    id: string(),
    type: literal("title"),
    text: string(),
    anchor: nullable(string()),
    level: defaulted(TitleLevelSchema, 1),
});

export type TitleBlock = Infer<typeof TitleBlockSchema>;
